import ApiService from "../api.services";

const MailServices = {
  send: async function(name, mail, phone, message, files) {
    const formData = new FormData();
    formData.append("name", name);
    formData.append("mail", mail);
    formData.append("phone", phone);
    formData.append("message", message);
    if (files && files.length > 0)
      for (let i = 0; i < files.length; i++)
        formData.append("files", files[i].raw);

    try {
      const res = await ApiService.post("/mail/talkToUs", formData, {
        "Content-Type": "multipart/form-data"
      });
      return res.data;
    } catch (error) {
      const errorData = error.data || error;
      throw new RequestError(
        errorData.statusCode || errorData.status,
        errorData.message || errorData.statusText
      );
    }
  }
};

export default MailServices;

export { MailServices };
